// ========================================
// CONFIGURACIÓN DEL CUESTIONARIO
// Definiciones estáticas para opciones del cuestionario
// ========================================

// === TIPOS DE PROBLEMAS (PAEV) ===
const PROBLEM_TYPES = [
    {
        id: 'sum',
        icon: '➕',
        color: '#4CAF50'
    },
    {
        id: 'subtraction',
        icon: '➖',
        color: '#FF9800'
    },
    {
        id: 'any',
        icon: '🎲',
        color: '#9C27B0'
    }
];

// === NIVELES DE DIFICULTAD ===
const DIFFICULTY_LEVELS = [
    {
        id: 'beginner',
        icon: '🔍',
        numberRange: [1, 10],
        allowedTypes: ['sum', 'subtraction'],     // Solo suma y resta
        allowCarrying: false,                     // SIN llevadas
        maxQuestions: 1,                          // 1 única pregunta
        useDistractors: false,                    // SIN datos distractores
        color: '#4CAF50',
        stars: 1
    },
    {
        id: 'advanced',
        icon: '⭐',
        numberRange: [10, 25],
        allowedTypes: ['sum', 'subtraction'],     // Solo suma y resta
        allowCarrying: false,                     // SIN llevadas
        maxQuestions: 1,                          // 1 única pregunta
        useDistractors: 'optional',               // Con o sin distractores
        color: '#FF9800',
        stars: 2
    },
    {
        id: 'expert',
        icon: '🏆',
        numberRange: [20, 49],
        allowedTypes: ['sum', 'subtraction'],     // Suma y resta (comparación opcional)
        allowCarrying: 'sum_only',                // Sumas CON o SIN llevadas, Restas SIN llevadas
        maxQuestions: 2,                          // 1 o 2 preguntas
        useDistractors: 'optional',               // Con o sin distractores
        color: '#F44336',
        stars: 3
    }
];

// Exportar para uso global y en app.js
window.PROBLEM_TYPES = PROBLEM_TYPES;
window.DIFFICULTY_LEVELS = DIFFICULTY_LEVELS;
if (typeof module !== 'undefined' && module.exports) {
    module.exports = {
        PROBLEM_TYPES,
        DIFFICULTY_LEVELS
    };
}
